import React from 'react'
import PropTypes from 'prop-types'
import { Container } from '@sainsburys-tech/fable'
import { InfoCircle } from '@sainsburys-tech/icons'
import '../../sass/components/signout-notification.scss'

class MerchandiserSignIn extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const {
      setHeaderBurger,
      setHeaderBack,
      setSignOutHeader,
      match
    } = this.props
    const { withbackbutton } = match.params

    if (withbackbutton === 'true') {
      setHeaderBack()
    } else {
      setHeaderBurger()
    }
    setSignOutHeader(true)
  }

  render() {
    const { signedInSite } = this.props
    const siteName = signedInSite ? signedInSite.name : ''
    return (
      <Container size="xl" as="div" className="dsib-merchSignIn">
        <div className="dsib-merchSignIn__content">
          <div className="dsib-merchSignIn__panel">
            <h2 className="dsib-merchSignIn__title">You're signed in</h2>
            {siteName ? (
              <div className="dsib-merchSignIn__siteName">{siteName}</div>
            ) : null}

            <div className="dsib-merchSignIn__banner" role="status" aria-live="polite">
              <InfoCircle className="dsib-merchSignIn__bannerIcon" aria-hidden="true" />
              <div className="dsib-merchSignIn__bannerText">
                You must ask a colleague to check your identification badge before starting work.
              </div>
            </div>

            <p className="dsib-merchSignIn__note">
              Please remember to sign out when you leave the site.
            </p>
          </div>
        </div>
      </Container>
    )
  }
}

MerchandiserSignIn.propTypes = {
  signedInSite: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  setHeaderBurger: PropTypes.func.isRequired,
  setHeaderBack: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      withbackbutton: PropTypes.string,
    }).isRequired,
  }).isRequired
}

MerchandiserSignIn.defaultProps = {
  signedInSite: {
    name: ''
  }
}

export default MerchandiserSignIn
